export const LIST_CHECKBOX = [
  { title: 'businessConciergeService.REGISTER_DATA', value: 'Register' },
  { title: 'businessConciergeService.FINANCIAL_DATA', value: 'Financial' },
  {
    title: 'businessConciergeService.HISTORICAL_DATA',
    value: 'Historical',
  },
]

export const LIST_RADIO = [
  { title: 'businessConciergeService.STANDARD', value: 'Standard' },
  { title: 'businessConciergeService.EXPRESS', value: 'Express' },
]

export const TYPE_BUTTON_FOOTER = {
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
}

export const LIST_BUTTON_FOOTER = [
  {
    title: 'businessConciergeService.CANCEL',
    value: TYPE_BUTTON_FOOTER.CANCEL,
  },
  {
    title: 'businessConciergeService.SUBMIT',
    value: TYPE_BUTTON_FOOTER.SUBMIT,
  },
]

export const KEYS_FIELD_LIST = {
  NAME: 'name',
  EMAIL: 'email',
  DATA_REQUIRED: 'requiredData',
  COUNTRY: 'country',
  REGIS_NUMBER: 'registrationNumber',
  PHONE: 'phone',
}
